import React from 'react';
import PropTypes from 'prop-types';

import DefaultModal from './DefaultModal';

const ActiveSubscriptionWarn = ({
  isShown,
  primaryAction,
  closeModal,
}) => (
  <DefaultModal
    isShown={isShown}
    closeModal={closeModal}
    title={t('activeSubscriptionWarn.title', { ns: i18next.Namespace.COMMON })}
    message={t('activeSubscriptionWarn.msg', { ns: i18next.Namespace.COMMON })}
    primaryBtnText={t('activeSubscriptionWarn.primaryBtn', { ns: i18next.Namespace.COMMON })}
    primaryAction={primaryAction}
    secondaryBtnText={t('activeSubscriptionWarn.secondaryBtn', { ns: i18next.Namespace.COMMON })}
    secondaryAction={closeModal}
  />
);

ActiveSubscriptionWarn.propTypes = {
  isShown: PropTypes.bool.isRequired,
  primaryAction: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ActiveSubscriptionWarn;
